import styled from 'styled-components';
import { StyledContentsProps, StyledRootProps } from './types';

export const Root = styled.div<StyledRootProps>`
  border-radius: inherit;
  display: block;
  height: ${(props) => (props.$basis === 'height' ? '100%' : 'auto')};
  width: ${(props) => (props.$basis === 'height' ? 'initial' : '100%')};
`;

export const Contents = styled.div<StyledContentsProps>`
  ${(props) => {
    switch (props.$basis) {
      case 'width':
        return `padding-bottom: ${(1 / props.$ratio) * 100}%;`;

      case 'height':
        return 'height: 100%;';

      default:
        return undefined;
    }
  }}
  position: relative;

  > :first-child {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    object-fit: ${(props) => props.$objectFit};
    position: absolute;
    width: 100%;
  }
`;

export const SVG = styled.svg`
  height: 100%;
  width: auto;
`;
